import { html } from '../../mixins/katapult-element.js';
import { KatapultEditorTemplate } from './katapult-editor-template.js';
import '@polymer/paper-radio-button/paper-radio-button.js';
import '@polymer/paper-radio-group/paper-radio-group.js';

import { CamelCase } from '../../modules/CamelCase.js';
import '../katapult-switcher/katapult-switcher.js';
import '../katapult-elements/katapult-button.js';
import '../input-element/input-element.js';
class KatapultDDSBundleEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style>
        #specSourceLabel {
          position: absolute;
          top: 0;
          right: 0;
          padding: 1.25em 1em;
          font-style: italic;
          color: var(--primary-text-color-faded);
          background: white;
        }
      </style>

      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/wire_spec"
        data="{{wireSpecAttribute}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/wire_name"
        data="{{wireNameAttribute}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/wire_overhead_type"
        data="{{wireOverheadTypeAttribute}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/messenger_spec"
        data="{{messengerSpecAttribute}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/diameter_in_inches"
        data="{{diameterInInchesAttribute}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/unit_weight_in_pounds_per_foot"
        data="{{unitWeightInPoundsPerFootAttribute}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/bundle_components"
        data="{{bundleComponentsAttribute}}"
      ></katapult-firebase-worker>

      <template is="dom-if" if="[[itemData.source]]">
        <div id="specSourceLabel">Source: [[itemData.source]]</div>
      </template>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <!-- Wire Spec -->
          <template is="dom-if" if="[[equal(step.id, 'wire_spec')]]" restamp>
            <paper-table slot="body" light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Wire Spec"
                    attribute_name="wire_spec"
                    hide-attribute-name
                    value="[[_itemData.wire_spec]]"
                    data-path="_itemData.wire_spec"
                    on-value-changed="updateProperty"
                    model="[[wireSpecAttribute]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Wire Name -->
          <template is="dom-if" if="[[equal(step.id, 'wire_name')]]" restamp>
            <paper-table slot="body" light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Wire Name"
                    attribute_name="wire_name"
                    hide-attribute-name
                    value="[[_itemData.wire_name]]"
                    data-path="_itemData.wire_name"
                    on-value-changed="updateProperty"
                    model="[[wireNameAttribute]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>

          <!-- Wire Overhead Type -->
          <template is="dom-if" if="[[equal(step.id, 'wire_overhead_type')]]" restamp>
            <paper-table slot="body" light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Wire Overhead Type"
                    attribute_name="wire_overhead_type"
                    hide-attribute-name
                    value="[[_itemData.wire_overhead_type]]"
                    data-path="_itemData.wire_overhead_type"
                    on-value-changed="updateWireOverheadType"
                    model="[[wireOverheadTypeAttribute]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Messenger Spec -->
          <template is="dom-if" if="[[equal(step.id, 'messenger_spec')]]" restamp>
            <paper-table slot="body" light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Messenger Spec"
                    attribute_name="messenger_spec"
                    hide-attribute-name
                    value="[[_itemData.messenger_spec]]"
                    data-path="_itemData.messenger_spec"
                    on-value-changed="updateProperty"
                    model="[[messengerSpecAttribute]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Lashed Bundle Options -->
          <template is="dom-if" if="[[equal(step.id, 'lashed_bundle_options')]]" restamp>
            <paper-table slot="body" light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <paper-radio-group selected="[[getSelectedBundleOption(_itemData.includeBundledComponents)]]">
                    <paper-radio-button name="specify_components" on-change="updateBundleOptions">Specify Components</paper-radio-button>
                    <paper-radio-button name="specify_diameter_weight" on-change="updateBundleOptions"
                      >Specify Diameter & Weight</paper-radio-button
                    >
                  </paper-radio-group>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Diameter in Inches -->
          <template is="dom-if" if="[[equal(step.id, 'diameter_in_inches')]]" restamp>
            <paper-table slot="body" light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Diameter in Inches"
                    attribute_name="diameter_in_inches"
                    hide-attribute-name
                    value="[[_itemData.diameter_in_inches]]"
                    data-path="_itemData.diameter_in_inches"
                    on-value-changed="updateProperty"
                    model="[[diameterInInchesAttribute]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Unit Weight in Pounds per Foot -->
          <template is="dom-if" if="[[equal(step.id, 'unit_weight_in_pounds_per_foot')]]" restamp>
            <paper-table slot="body" light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Unit Weight in Pounds per Foot"
                    attribute_name="unit_weight_in_pounds_per_foot"
                    hide-attribute-name
                    value="[[_itemData.unit_weight_in_pounds_per_foot]]"
                    data-path="_itemData.unit_weight_in_pounds_per_foot"
                    on-value-changed="updateProperty"
                    model="[[unitWeightInPoundsPerFootAttribute]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Bundled Components -->
          <template is="dom-if" if="[[equal(step.id, 'bundle_components')]]" restamp>
            <paper-table slot="body" rounded white outline grow overflow-hidden style="max-width: 600px;">
              <paper-row short grey>
                <paper-cell icon></paper-cell>
                <paper-cell>Component</paper-cell>
                <paper-cell icon></paper-cell>
              </paper-row>
              <!-- Body -->
              <paper-table-scroll on-sort-changed="componentsSortChanged">
                <template is="dom-repeat" items="[[_itemData.bundle_components]]" mutable-data>
                  <paper-row white divider slot="sortable">
                    <paper-cell drag-handle icon>
                      <material-icon icon="drag_indicator"></material-icon>
                    </paper-cell>
                    <paper-cell>[[CamelCase(item.value)]]</paper-cell>
                    <paper-cell icon-button>
                      <katapult-button iconOnly noBorder icon="delete" on-click="removeComponentButtonClicked"></katapult-button>
                    </paper-cell>
                  </paper-row>
                </template>
              </paper-table-scroll>
              <!-- Add Drop Down -->
              <paper-row>
                <paper-cell>
                  <input-element
                    style="flex-grow: 1;"
                    label="Wire Spec"
                    attribute_name="bundle_components"
                    hide-attribute-name
                    value="[[item.value]]"
                    on-value-changed="componentSelected"
                    model="[[bundleComponentsAttribute]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  constructor() {
    super();
    this.computedLabel = {
      dependencies: [{ path: 'wire_spec' }],
      compute: (spec) => spec ?? 'Untitled Bundle'
    };
    this.CamelCase = CamelCase;

    this.bundleComponentsPath = '_itemData.bundle_components';
  }

  ready() {
    super.ready();

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'wire_spec',
        title: 'Wire Spec',
        trigger: () => this.get('_itemData.wire_spec') != null
      },
      {
        id: 'wire_name',
        title: 'Wire Name',
        trigger: () => this.get('_itemData.wire_name') != null
      },
      {
        id: 'wire_overhead_type',
        title: 'Wire Overhead Type',
        trigger: () => this.get('_itemData.wire_overhead_type') != null
      },
      {
        id: 'messenger_spec',
        title: 'Messenger Spec',
        trigger: () => this.get('_itemData.messenger_spec') != null,
        if: () => this.get('_itemData.wire_overhead_type') == 'Lashed'
      },
      {
        id: 'lashed_bundle_options',
        title: 'Lashed Bundle Options',
        trigger: () => this.get('_itemData.wire_overhead_type') == 'Lashed',
        if: () => this.get('_itemData.wire_overhead_type') == 'Lashed'
      },
      {
        id: 'bundle_components',
        title: 'Bundled Components',
        trigger: () => this.get(this.bundleComponentsPath) != null,
        if: () => this.get('_itemData.wire_overhead_type') == 'Lashed' && this.get('_itemData.includeBundledComponents') === true
      },
      {
        id: 'diameter_in_inches',
        title: 'Diameter in Inches',
        trigger: () => this.get('_itemData.diameter_in_inches') != null,
        if: () => this.get('_itemData.wire_overhead_type') == 'Lashed' && this.get('_itemData.includeBundledComponents') === false
      },
      {
        id: 'unit_weight_in_pounds_per_foot',
        title: 'Unit Weight in Pounds per Foot',
        trigger: () => this.get('_itemData.unit_weight_in_pounds_per_foot') != null,
        if: () => this.get('_itemData.wire_overhead_type') == 'Lashed' && this.get('_itemData.includeBundledComponents') === false
      }
    ]);
  }

  addComponent(component) {
    // Ensure bundleComponents exists and is an array.
    if (!Array.isArray(this.get(this.bundleComponentsPath))) this.deepSet(this.bundleComponentsPath, []);

    const bundleComponents = this.get(this.bundleComponentsPath);

    if (component && !bundleComponents.find((x) => x.value == component)) {
      this.push(this.bundleComponentsPath, { value: component });
    }
  }

  componentSelected(e) {
    const dropdown = e.currentTarget;
    const component = e.detail.value;
    this.addComponent(component);
    dropdown.value = null;
  }

  removeComponentButtonClicked(e) {
    const index = e.model.index;
    this.splice(this.bundleComponentsPath, index, 1);
  }

  componentsSortChanged(e) {
    const removed = this.splice(this.bundleComponentsPath, e.detail.prevIndex, 1);
    this.splice(this.bundleComponentsPath, e.detail.index, 0, removed[0]);
  }

  beforeSave() {
    this._itemData.source = `Manual Entry - ${katapultAuth.user.email} (${new Date().toLocaleDateString()})`;
  }

  updateWireOverheadType(e) {
    this.set('_itemData.wire_overhead_type', e.detail.value);
    this.set('_itemData.messenger_spec', null);
    this.set('_itemData.includeBundledComponents', null);
    this.set('_itemData.diameter_in_inches', null);
    this.set('_itemData.unit_weight_in_pounds_per_foot', null);
    this.set(this.bundleComponentsPath, []);

    this.updateProperty(e);
  }

  getSelectedBundleOption() {
    switch (this._itemData?.includeBundledComponents) {
      case true:
        return 'specify_components';
      case false:
        return 'specify_diameter_weight';
      default:
        return null;
    }
  }

  updateBundleOptions(e) {
    const target = e.target;
    const type = target.name;
    if (type == 'specify_components') {
      this.set('_itemData.includeBundledComponents', true);
      this.set('_itemData.diameter_in_inches', null);
      this.set('_itemData.unit_weight_in_pounds_per_foot', null);
    } else {
      this.set('_itemData.includeBundledComponents', false);
      this.set(this.bundleComponentsPath, []);
    }
  }
}

customElements.define('katapult-dds-bundle-editor', KatapultDDSBundleEditor);
